import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

function RizomaLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Rizoma"
    >
      <rect width="44" height="44" rx="9" fill="#2D5016" />
      <circle cx="14" cy="22" r="4.5" fill="white" />
      <circle cx="27" cy="14" r="3.5" fill="white" opacity="0.75" />
      <circle cx="27" cy="30" r="3.5" fill="white" opacity="0.75" />
      <circle cx="37" cy="22" r="2.5" fill="#C17BC0" opacity="0.9" />
      <line x1="14" y1="22" x2="24" y2="15" stroke="white" strokeWidth="1.4" opacity="0.5" />
      <line x1="14" y1="22" x2="24" y2="29" stroke="white" strokeWidth="1.4" opacity="0.5" />
      <line x1="27" y1="14" x2="35" y2="22" stroke="#C17BC0" strokeWidth="1.2" opacity="0.5" />
      <line x1="27" y1="30" x2="35" y2="22" stroke="#C17BC0" strokeWidth="1.2" opacity="0.5" />
    </svg>
  );
}

export function TrialWall() {
  return (
    <div className="fixed inset-0 bg-background flex items-center justify-center z-50 p-4">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="flex justify-center mb-2">
            <RizomaLogo className="h-12 w-12" />
          </div>
          <CardTitle>Seu trial encerrou</CardTitle>
          <CardDescription>
            Assine por R$99/mês para continuar acessando seus dados.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button
            className="w-full"
            onClick={() => window.location.href = '/configuracoes/billing'}
          >
            Assinar por R$99/mês
          </Button>
          <p className="text-xs text-muted-foreground">
            Seus dados estão seguros e serão mantidos por 30 dias após o encerramento.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
